module.exports = __webpack_public_path__ + "img/5.c7d2f3ea.png";